import { Col, Layout, Row } from 'antd'
import { Helmet } from 'react-helmet'
import UsersTable from '../../../components/Admin/UsersTable'
import { StyledLayout } from './Users.styles'

const { Content } = Layout

const Profile: React.FC = () => {
    return (
        <StyledLayout>
            <Helmet title="Profile" />
            <Content style={{ padding: '0 50px' }}>
                <Row justify="center" gutter={[16, 16]}>
                    <Col span={24}>
                        <UsersTable />
                    </Col>
                </Row>
            </Content>
        </StyledLayout>
    )
}

export default Profile
